import React from "react";
import { View, Text } from "react-native";
import { useNavigation } from "@react-navigation/core";
import HeaderTabs from "../../components/HeaderTabs";
import CryptoListSelection from "../../components/CryptoListSelection";
import { FormattedMessage } from "react-intl";
import { id } from "date-fns/locale";
import GoBackButton from "../../components/GoBackButton";

const DepositCryptoSelection = () => {
  const navigation = useNavigation();

  function onCryptoSelected(crypto) {
    const { acronym, activeId, minValue, name, step } = crypto;
    navigation.navigate({
      name: "DepositCrypto",
      params: {
        acronym: acronym,
        activeId: activeId,
        minValue: minValue,
        name: name,
        step: step,
      },
    });
  }

  return (
    <View>
      <HeaderTabs
        title={<FormattedMessage id="depositCrypyoSelection.titleDeposit" />}
        subtitle={
          <Text style={{ fontWeight: "500", marginBottom: 12 }}>
            {/* <FormattedMessage id="depositCrypyoSelection.escolhaCripto" /> */}
            <FormattedMessage id="depositCrypyoSelection.emBreve" />
          </Text>
        }
      />
      <GoBackButton />
      <CryptoListSelection onItemPressed={onCryptoSelected} />
    </View>
  );
};

export default DepositCryptoSelection;
